import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import "react-table/react-table.css";
import couterpart from 'counterpart';

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import WorkOrderDataService from '../services/WorkOrderDataService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';
import { WO_COMPLETED_CK, WO_ASSIGNED_WORKER, WO_READY, WO_NHAM } from '../constants';

class CardByWorker extends Component {
  constructor () {
    super();
    this.state = {
      count: 0,
      worker: '',
      statusList: [],
      allStatus: []
    };
  }

  componentDidMount () {
    WorkOrderDataService.countByWorker(this.props.info).then(data => {
      console.log('Count by worker and statusList', data)
      this.setState({
          workerName: this.props.info.workerName, 
          statusList: this.props.info.statusList,
          worker: this.props.info.worker,
          count:  data
      });
    });
  }

  viewDetails() {
    sessionStorage.removeItem('prod.fromDate')
    sessionStorage.removeItem('wo.fromDate')
    sessionStorage.removeItem('prodKhac.fromDate')
    if (AuthenticationService.isDesigner()){
      WorkOrderUtil.saveItem('wo.woStatus', this.state.status);
      this.props.history.push("/workOrders?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
      WorkOrderUtil.saveItem('prod.woStatus', this.state.status);
      this.props.history.push("/products?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isKhac()){
      WorkOrderUtil.saveItem('prodKhac.woStatus', 0);
      WorkOrderUtil.saveItem('prodKhac.workerName', this.state.workerName);
      this.props.history.push("/khacs?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isSupervisor()){
      WorkOrderUtil.saveItem('superv.selectedWoStatusList', JSON.stringify([
        {id: WO_COMPLETED_CK, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, WO_COMPLETED_CK)},
        {id: WO_ASSIGNED_WORKER, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, WO_ASSIGNED_WORKER)},
        {id: WO_READY, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, WO_READY)},
        {id: WO_NHAM, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, WO_NHAM)}
      ]));
      WorkOrderUtil.saveItem('superv.workerName', this.state.workerName);
      this.props.history.push("/super?status=" + this.state.status);
      return;
    }        
  }

  render() {
    if (this.props.info === undefined){
      return (<></>);
    }
    return (
      <Card style={{ width: '18rem' }}>
        <Card.Body>
          <Card.Title> { this.state.workerName }</Card.Title>
          <Card.Text>
            { this.state.count }
          </Card.Text>
          <Button className="myButton" onClick={this.viewDetails.bind(this)}>{ couterpart.translate('wo_goto_details') }</Button>
        </Card.Body>
      </Card>  
    )
  }
}

export default withRouter(CardByWorker);